import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const StrikethroughIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 12H20M17 12C17 14.761 14.761 17 12 17C9.239 17 7 14.761 7 12M7.5 7C7.5 7 8.5 4 12 4C14.5 4 16.5 5.5 16.5 7.5C16.5 9 15.5 10 14.5 10.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

StrikethroughIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(StrikethroughIcon);
